import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import TileButtons from './tile-buttons'
import { useWizardFormContext } from 'components/wizard-form/context'
import useEventDetails from './use-event-details'
import PropTypes from 'prop-types'

// Child components
import EventName from './event-name'
import GroupEventTagSelectionInput from './group-event-tag-selection-input'
import SelectLocation from './select-location'
import EventDescription from './event-description'
import AcademySelect from './academy-select'
import SelectAssistantCoaches from './select-assistant-coaches'
import AgeGroupSelect from 'components/age-group-select'
const AcademyAndLocationSelection = ({ isAcademyEvent, academyId }) => (
  <>
    {isAcademyEvent && (
      <Box mb={4}>
        <AcademySelect />
      </Box>
    )}
    {((isAcademyEvent && academyId !== '') || !isAcademyEvent) && (
      <Box mb={4}>
        <SelectLocation />
      </Box>
    )}
  </>
)

const EventDetails = () => {
  const {
    register,
    academyRequired,
    academyId,
    isAcademyEvent,
    setIsAcademyEvent,
  } = useEventDetails()
  const {
    extraData: { coachAcademies },
  } = useWizardFormContext()

  const hasAcademies = coachAcademies.length >= 1

  useEffect(() => {
    register('academyRequired')
  }, [register])

  useEffect(() => {
    setIsAcademyEvent(academyRequired)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [academyRequired])

  return (
    <Container maxWidth="md">
      <Box mb={6}>
        <Typography variant="h4" align="center">
          Enter details about your offering.
        </Typography>
      </Box>
      <Box mb={6}>
        <EventName />
      </Box>
      {hasAcademies && (
        <Box>
          <Box mb={3}>
            <Typography variant="h4" align="center">
              Who is hosting this event?
            </Typography>
          </Box>
          {!academyRequired && (
            <Box mb={6} display="flex" justifyContent="center">
              <TileButtons
                prompt=""
                isAcademyEvent={isAcademyEvent}
                setIsAcademyEvent={setIsAcademyEvent}
                controlName="academyRequired"
              />
            </Box>
          )}
        </Box>
      )}
      <AcademyAndLocationSelection
        isAcademyEvent={isAcademyEvent}
        academyId={academyId}
      />
      {isAcademyEvent && academyId !== '' && (
        <Box mb={4}>
          <SelectAssistantCoaches />
        </Box>
      )}
      <Box style={{ marginBottom: '1.5rem' }}>
        <Typography variant="h5" align="center">
          Choose up to five (5) tags for this offering:
        </Typography>
      </Box>
      <Box mb={6}>
        <GroupEventTagSelectionInput />
      </Box>
      <Box>
        <Box align="center">
          <Box style={{ paddingBottom: '8px' }}>
            <Typography variant="h6">Specify Age Group:</Typography>
          </Box>
          <Box style={{ paddingBottom: '20px' }}>
            <Typography variant="body">
              Would you like to specify an age group for this event?
            </Typography>
          </Box>
        </Box>
        <Box mb={4}>
          <AgeGroupSelect />
        </Box>
      </Box>
      <Box mb={4}>
        <EventDescription />
      </Box>
    </Container>
  )
}

export default EventDetails

PropTypes.AcademyAndLocationSelection = {
  isAcademyEvent: PropTypes.bool,
  academyId: PropTypes.string,
}
